import { rankings } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full border-b border-background-200 bg-background-100">
      <div className="w-full px-4 py-14 md:px-8 md:py-16">
        <SectionHeading
          index="02"
          title="平台推荐榜"
          desc="按内容丰富度、更新速度、访问稳定性等维度综合观感排出的参考榜位，条目按名次排列，方便你横向对照后再决定先去哪一个。"
        />

        <div className="mt-8 w-full overflow-hidden rounded-lg border border-background-200 bg-background-50">
          <div className="hidden grid-cols-[64px_minmax(0,1.6fr)_minmax(0,1fr)_100px_90px] items-center gap-4 border-b border-background-200 bg-secondary-50 px-6 py-3 text-xs font-medium text-secondary-900 lg:grid">
            <span>名次</span>
            <span>平台 / 简介</span>
            <span>类型 · 节奏</span>
            <span>入选标签</span>
            <span className="text-right">综合评分</span>
          </div>

          {rankings.map((item) => (
            <article
              key={item.name}
              className="grid grid-cols-1 gap-4 border-b border-background-200 px-4 py-5 transition-colors last:border-b-0 hover:bg-background-100 md:px-6 lg:grid-cols-[64px_minmax(0,1.6fr)_minmax(0,1fr)_100px_90px] lg:items-center lg:gap-4"
            >
              <div className="flex items-center gap-3 lg:block">
                <span
                  className={`flex h-9 w-9 items-center justify-center rounded-md font-heading text-base font-bold ${
                    item.rank <= 3
                      ? "bg-accent-500 text-background-50"
                      : "bg-background-200 text-foreground-700"
                  }`}
                >
                  {item.rank}
                </span>
                <span className="text-xs text-foreground-500 lg:hidden">
                  {item.type} · {item.freq}
                </span>
              </div>

              <div className="min-w-0">
                <div className="flex flex-wrap items-center gap-2">
                  <h3 className="font-heading text-base font-semibold text-foreground-950">
                    {item.name}
                  </h3>
                  <span className="rounded bg-background-200 px-1.5 py-0.5 text-[11px] text-foreground-600">
                    {item.domain}
                  </span>
                </div>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">
                  {item.highlight}
                </p>
              </div>

              <div className="hidden lg:block">
                <p className="text-sm text-foreground-800">{item.type}</p>
                <p className="mt-0.5 text-xs text-foreground-500">{item.freq}</p>
              </div>

              <div className="flex flex-wrap gap-1.5">
                {item.tags.map((tag) => (
                  <span
                    key={tag}
                    className="whitespace-nowrap rounded-full bg-primary-100 px-2.5 py-1 text-[11px] font-medium text-primary-800"
                  >
                    {tag}
                  </span>
                ))}
              </div>

              <div className="flex items-center gap-2 lg:justify-end">
                <span className="font-heading text-lg font-bold text-foreground-950">
                  {item.score}
                </span>
                <span className="text-xs text-foreground-500">分</span>
              </div>
            </article>
          ))}
        </div>

        <p className="mt-4 text-xs leading-relaxed text-foreground-500">
          说明：榜位为综合观感参考，非绝对标准；不同浏览习惯适合的平台并不相同。
        </p>
      </div>
    </section>
  );
}